var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCultLogo = function SvgCultLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.848 25.065H1.604c-.852 0-1.544.692-1.544 1.542v2.19c0 .85.692 1.542 1.544 1.542h45.244c.852 0 1.545-.691 1.545-1.542v-2.19c0-.85-.693-1.542-1.545-1.542M27.309 33.863a1.543 1.543 0 0 0-1.172-.537h-3.914c-.45 0-.877.196-1.17.537L9.15 47.653c-.269.313-.4.71-.369 1.122.032.41.221.784.534 1.053l1.663 1.427a1.544 1.544 0 0 0 2.177-.165l10.117-11.715a1.195 1.195 0 0 1 1.814 0l10.127 11.77a1.544 1.544 0 0 0 2.178.166l1.662-1.427c.313-.268.502-.642.533-1.053.03-.41-.1-.81-.368-1.122l-11.91-13.846"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.997 45.78h-1.633c-.638 0-1.156.517-1.156 1.155v6.567c0 .638.518 1.155 1.156 1.155h1.633c.638 0 1.155-.517 1.155-1.155v-6.567c0-.638-.517-1.155-1.155-1.155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA2C6C",
    d: "M23.354 5.999h1.653c.638 0 1.156-.517 1.156-1.155v-3.69C26.163.518 25.645 0 25.007 0h-1.653c-.639 0-1.156.517-1.156 1.155v3.689c0 .638.517 1.155 1.156 1.155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B4DF",
    d: "M13.805 35.196l-.905-1.348a1.156 1.156 0 0 0-1.603-.316l-7.32 4.897a1.154 1.154 0 0 0-.316 1.603l.906 1.348c.356.529 1.073.67 1.603.315l7.319-4.896c.53-.355.672-1.073.316-1.603"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.508 20.693c.356.528 1.073.67 1.602.315l7.32-4.897c.53-.355.672-1.073.316-1.602l-.906-1.349a1.157 1.157 0 0 0-1.603-.316l-7.32 4.897a1.154 1.154 0 0 0-.315 1.604l.906 1.348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBD020",
    d: "M44.472 38.487l-7.32-4.898a1.155 1.155 0 0 0-1.603.317l-.905 1.348a1.153 1.153 0 0 0 .316 1.603l7.32 4.897a1.156 1.156 0 0 0 1.601-.316l.907-1.348a1.154 1.154 0 0 0-.316-1.603"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.012 16.143l7.318 4.897c.53.355 1.247.213 1.603-.315l.906-1.348a1.154 1.154 0 0 0-.316-1.604l-7.32-4.897a1.156 1.156 0 0 0-1.603.316l-.905 1.349a1.154 1.154 0 0 0 .317 1.602M24.18 12.706c1.602 0 2.9 1.297 2.9 2.897 0 1.6-1.298 2.897-2.9 2.897a2.898 2.898 0 0 1-2.9-2.897c0-1.6 1.299-2.897 2.9-2.897zm0 9.935c3.891 0 7.045-3.15 7.045-7.038a7.041 7.041 0 0 0-7.045-7.038 7.042 7.042 0 0 0-7.045 7.038 7.042 7.042 0 0 0 7.045 7.038z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCultLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cult-logo.4cc268ff.svg";
export { ForwardRef as ReactComponent };